/* eslint-disable @typescript-eslint/no-explicit-any */

import { detectBrowserName } from '../detectBrowser'
import { EVENTS_SAMPLING_RATE, getSampleGroup } from '../getSampleGroup'
import { isProductionBuild } from '../isProductionBuild'
import { TrackerClients } from '../tracker/trackerClients'
import trackerFactory, { getConfiguredTracker } from '../tracker/trackerFactory'

const CONSOLE_MESSAGE_PREFIX = 'Klarna Web SDK:'

const logStyle = 'color: black; background-color: #FFB3C7; padding: 2px;'

const browserName = detectBrowserName()

export function logError(
  message: string | Error,
  logEvent = true,
  eventName = 'metric_merchant_error',
  useConfiguredTracker = false
) {
  console.error(`%c${CONSOLE_MESSAGE_PREFIX} ${message}`, logStyle)

  if (logEvent) {
    if (useConfiguredTracker) {
      // Try to use the configured tracker first (has merchantUrl and other data)
      const configuredTracker = getConfiguredTracker(TrackerClients.websdk)
      if (configuredTracker) {
        configuredTracker.event(eventName, { message, browserName })
        return
      }
    }

    // Fallback to creating new tracker (current behavior for backward compatibility)
    const fallbackTracker = trackerFactory(TrackerClients.websdk)
    fallbackTracker.event(eventName, { message, browserName })
  }
}

export function logWarn(message: string, eventName = 'metric_merchant_warn', skipSampling = false) {
  console.warn(`%c${CONSOLE_MESSAGE_PREFIX} ${message}`, logStyle)

  if (getSampleGroup(EVENTS_SAMPLING_RATE.MERCHANT_WARN) || skipSampling) {
    const tracker = trackerFactory(TrackerClients.websdk)
    tracker.event(eventName, { message })
  }
}

export function logInfo(message: string) {
  console.info(`%c${CONSOLE_MESSAGE_PREFIX} ${message}`, logStyle)

  const tracker = trackerFactory(TrackerClients.websdk)
  tracker.event('merchant_info', { message })
}

export const devLogger = {
  info: (message: string) => !isProductionBuild() && logInfo(message),
  warn: (message: string) => !isProductionBuild() && logWarn(message),
  error: (message: string) => !isProductionBuild() && logError(message),
}
